import axios from 'axios';
import { SearchForAddressByZipCodeResponse } from '../models';
import { getApiUrlWithoutEndSlash } from '../shared';

// classicのコードを流用しているので、
// `zipcallback({ zipcode: { a1: { ...} } });`
// のような文字列が返ってくるため、パースしてオブジェクトに変換して返す
export const RESPONSE_ZIP_CODE_START_WITH = 'zipcallback(';
export const RESPONSE_ZIP_CODE_END_WITH = ');';
export const emptyZipCode: SearchForAddressByZipCodeResponse = {
  zipcode: {},
};

export const parseZipCodeResponse = (
  responseZipCodeString: string,
): SearchForAddressByZipCodeResponse => {
  const startWith = responseZipCodeString.startsWith(
    RESPONSE_ZIP_CODE_START_WITH,
  );
  const endWith = responseZipCodeString.endsWith(RESPONSE_ZIP_CODE_END_WITH);
  if (startWith && endWith) {
    const zipCodeString = responseZipCodeString
      .slice(RESPONSE_ZIP_CODE_START_WITH.length)
      .slice(0, -RESPONSE_ZIP_CODE_END_WITH.length);
    try {
      const json = JSON.parse(
        zipCodeString,
      ) as SearchForAddressByZipCodeResponse;
      return (json?.zipcode?.a1 && json) || emptyZipCode;
    } catch {
      return emptyZipCode;
    }
  }
  return emptyZipCode;
};

export const searchForAddressByZipCode = async (
  zipCode: string,
  searchZipCodeApiEndpoint?: string,
): Promise<SearchForAddressByZipCodeResponse> => {
  // バックエンドから新しくapiEndpointをもらうようにしたため、それを使う
  // apiEndpointは常に入ってくるはずだが、
  // 一応もともと使っていたエンドポイントもフォールバックとして残しておく
  const endpoint =
    searchZipCodeApiEndpoint ?? `${getApiUrlWithoutEndSlash()}/searchZipCode`;
  const address = await axios.get<string>(endpoint, {
    params: {
      zip: zipCode,
    },
  });
  return parseZipCodeResponse(address.data);
};
